import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';

import {
  SkeletonLoader,
  Heading,
  Row,
  InitialAvatarIcon,
  BaseText,
  ButtonIconPrimary,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';
import { OrderDetailsSheet } from '..';

import {
  IOrderGroup,
  IOrderItem
} from '@/modules/wealth/services/portfolio-orders';

interface Props {
  isLoading?: boolean;
  concludedOrders: IOrderGroup[];
  isScrolling?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConcludedOrders',
  props: {
    isLoading: { type: Boolean, default: false },
    concludedOrders: null,
    isScrolling: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isLoading: boolean, concludedOrders: IOrderGroup[], isScrolling: boolean };



const scrollTop = ref(document.documentElement.scrollTop);
const isOrderDetailsOpen = ref(false);
const selectedOrder = ref<IOrderItem | null>(null);

const orders = computed(() => {
  return props.concludedOrders;
});

const hasScrolled = computed(() => {
  return scrollTop.value >= 1000;
});

const openOrderDetails = (order: IOrderItem) => {
  selectedOrder.value = order;
  isOrderDetailsOpen.value = true;
};

function goToTop() {
  document.documentElement.scrollTo(0, 0);
}

function handleScrollTop() {
  scrollTop.value = document.documentElement.scrollTop;
}

onMounted(async () => {
  window.addEventListener('scroll', handleScrollTop);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScrollTop);
});

return { __sfc: true,props, scrollTop, isOrderDetailsOpen, selectedOrder, orders, hasScrolled, openOrderDetails, goToTop, handleScrollTop, SkeletonLoader, Heading, Row, InitialAvatarIcon, BaseText, ButtonIconPrimary, LoaderIndicator, Money, OrderDetailsSheet }
}

})